<!-- src/components/DashboardLayout.html -->
<div class="dashboard-layout" :class="{ 'menu-open': isMobileMenuOpen }">
  
  <!-- Mobile Top Bar (Solo Mobile) -->
  <header class="mobile-top-bar border-bottom">
    <h2 class="brand-title">Luna</h2>
    <button class="menu-toggle" @click="toggleMobileMenu">
      <Menu v-if="!isMobileMenuOpen" :size="24" />
      <X v-else :size="24" />
    </button>
  </header>

  <!-- Overlay sfondo quando il menu è aperto -->
  <div class="sidebar-overlay" @click="closeMobileMenu"></div>

  <!-- Sidebar / Wafer -->
  <aside class="sidebar border-right" :class="{ 'is-visible': isMobileMenuOpen }">
    <div class="sidebar-header border-bottom desktop-only">
      <h2 class="brand-title">Luna Backoffice</h2>
    </div>
    
    <nav class="sidebar-nav">
      <ul class="nav-list">
        <li v-for="item in menuItems" :key="item.path" class="nav-item">
          <RouterLink 
            :to="item.path" 
            class="nav-link rounded-soft"
            :class="{ 'active': isActive(item.path) }"
          >
            <component :is="item.icon" :size="20" class="nav-icon" stroke-width="1.5" />
            <span>{{ item.name }}</span>
          </RouterLink>
        </li>
      </ul>
    </nav>

    <div class="sidebar-footer border-top">
      <RouterLink to="/login" class="nav-link rounded-soft logout-link">
        <LogOut :size="20" class="nav-icon" stroke-width="1.5" />
        <span>Esci</span>
      </RouterLink>
    </div>
  </aside>

  <!-- Main Content Area -->
  <main class="main-content">
    <div class="content-wrapper">
      <RouterView />
    </div>
  </main>
</div>